export default __webpack_public_path__ + "static/media/milestone 250.4bc9f753.svg";